import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { redirect, useLocation, useRouteLoaderData } from 'react-router-dom';
import { useAuth } from './providers/auth';

export const redirectToLogin = (referrer = '') => {
  let redirectUrl = '/login'

  if (referrer) {
    // Loaders pass absolute request.url, AuthManager passes pathname.
    // Store only path+search+hash so Login can `redirect()` client-side (no full reload / open redirect).
    let from = referrer
    try {
      if (/^https?:\/\//i.test(referrer)) {
        const u = new URL(referrer)
        from = `${u.pathname}${u.search}${u.hash}`
      }
    } catch {
      from = referrer
    }
    if (from && from !== '/login') {
      let params = new URLSearchParams();
      params.set("from", from);
      redirectUrl = redirectUrl + "?" + params.toString()
    }
  }
  return redirect(redirectUrl)
}

export default function AuthManager(props) {
  const { children } = props;
  const { user } = useRouteLoaderData('Root');
  const { isPageLoading } = useAuth();
  const location = useLocation()

  let authenticated = !isEmpty(user);
  // // todo: need to remove the line below
  // // marked statically for now, use the presence of user to find authenticated status
  // authenticated = true;

  if (isPageLoading) {
    return (
      <div className="loading-screen">
        Loading...
      </div>
    );
  }


  if (!authenticated) return (
    // <Login onLogin={actions.onLogin} />
    redirectToLogin(`${location.pathname}${location.search}${location.hash}`)
  )
  return children
}

AuthManager.propTypes = {
  children: PropTypes.element,
}
